import _ from 'lodash';

export const parseJson = json => {
    try {
        json = JSON.parse(json);

        if (_.isObject(json) && !_.isEmpty(json)) {
            return json;
        }
    } catch (e) {}

    return [];
};
